<template>
  <div>
    <h1>Shift Swap Requests</h1>
    <div class="row">
      <div class="col">
        <p>Out of consideration for SVs and the conference, online shift swapping has been disabled.</p>
        <p>Shift swaps will only be accepted at the SV Office or by email: <a href="mailto:sv-2018@siggraph.org">sv-2018@siggraph.org</a>.
          Confirmation must be received from both parties.</p>
        <p>We <strong>WILL NOT</strong> accept swap requests without a SV to swap with.</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'ListShiftSwapRequests',
    data () {
      return {
        createdFields: [
          { key: 'shift', label: 'Your Shift' },
          { key: 'swapped_shift', label: 'Requested Shift' },
          { key: 'sv', label: 'Accepted By' },
          { key: 'status', label: 'Status' },
          { key: 'actions', label: 'Actions' }
        ],
        assignedFields: [
          { key: 'shift', label: 'Your Shift' },
          { key: 'swapped_shift', label: 'Their Shift' },
          { key: 'sv', label: 'Requested By' },
          { key: 'status', label: 'Status' },
          { key: 'actions', label: 'Actions' }
        ],
        openFields: [
          { key: 'day', label: 'Day' },
          { key: 'start_time', label: 'Start Time' },
          { key: 'end_time', label: 'End Time' },
          { key: 'name', label: 'Student Volunteer' },
          { key: 'accept', label: 'Accept' }
        ],
        selectedRequest: {
          shift: {
            day: '2019-07-26',
            start_time: '',
            end_time: '',
            venue: {
              name: '',
              location: ''
            }
          },
          swapped_shift: {
            day: '2019-07-26',
            start_time: '',
            end_time: '',
            venue: {
              name: '',
              location: ''
            }
          }
        },
        isDeleting: null,
        isAccepting: null,
        isDeclining: null
      }
    },
    methods: {
      formatName: function (sv) {
        let name = sv.given_name + ' ' + sv.family_name
        if (sv.nickname && sv.nickname !== '' && sv.nickname !== sv.given_name) {
          name = sv.given_name + ' "' + sv.nickname + '" ' + sv.family_name
        }
        return name
      },
      formatStatus: function (status) {
        if (status === null) {
          return 'OPEN'
        }
        if (status) {
          return 'ACCEPTED'
        }
        return 'DECLINED'
      },
      formattedDay: function (day) {
        return moment(day).utc().format('ddd MMM Do')
      },
      deleteRequest: function (id) {
        this.isDeleting = id
        this.$store.dispatch('schedule/deleteRequest', id)
      },
      resetSelectedRequest: function () {
        this.selectedRequest = {
          shift: {
            day: '2019-07-26',
            start_time: '',
            end_time: '',
            venue: {
              name: '',
              location: ''
            }
          },
          swapped_shift: {
            day: '2019-07-26',
            start_time: '',
            end_time: '',
            venue: {
              name: '',
              location: ''
            }
          }
        }
      },
      acceptRequest: function (id) {
        this.resetSelectedRequest()
        this.selectedRequest = this.shiftSwapRequests.shiftRequests.find(request => {
          return request.id === id
        })
        this.$refs.acceptModal.show()
      },
      confirmAcceptRequest: function () {
        this.isAccepting = this.selectedRequest.id
        this.$store.dispatch('schedule/acceptRequest', {
          shift_swap_request_id: this.selectedRequest.id,
          swapped_shift_id: this.selectedRequest.swapped_shift.id
        })
      },
      declineRequest: function (id) {
        this.isDeclining = id
        this.$store.dispatch('schedule/declineRequest', {shift_swap_request_id: id})
      }
    },
    computed: {
      ...mapState('schedule', ['shiftSwapRequests', 'shiftSwapRequestsLoaded']),
      ...mapGetters('schedule', ['getQualifyingOpenRequests', 'qualifyingShiftRequests'])
    },
    created () {
      if (!this.$store.state.schedule.isLoaded) {
        this.$store.dispatch('schedule/load')
      }
      if (!this.$store.state.schedule.swapShiftsLoaded) {
        this.$store.dispatch('schedule/loadShiftSwapRequests')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/schedule/ListShiftSwapRequests.vue